export default __webpack_public_path__ + "static/media/support.c5d55fc3.svg";